import type { DPState } from '@rehookify/datepicker';
import type { DateTime } from 'luxon';
import { createContext } from 'react';

export interface DatePickerContextType {
  dpState: DPState;
  include?: DateTime[];
  renderDay?: (data: { date: DateTime; isSelected: boolean }) => React.ReactNode;
  timezone: string;
}

export const DatePickerContext = createContext<DatePickerContextType>({} as DatePickerContextType);
